module.exports = __webpack_public_path__ + "img/9791156331902.15f2b804.jpg";